import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthenticationBloc } from '@kp/auth/authentication.bloc';
import { DataLinkBloc } from '@kp/data-link/data-link.bloc';
import { DataStoreService } from '@kservice';
import { UserType } from '@ktypes/enums';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ExistingAccountGuard {
  constructor(
    private _authenticationBloc: AuthenticationBloc,
    private _dataStoreService: DataStoreService,
    private _router: Router
  ) {}

  canActivate(/*route: ActivatedRouteSnapshot, state: RouterStateSnapshot*/): Observable<boolean | UrlTree> {
    return combineLatest([this._dataStoreService.authData$, this._authenticationBloc.existingAccount$]).pipe(
      map(([authData, existingAccountStatus]) => {
        if (
          !DataLinkBloc.isExternalPulseSurvey &&
          (existingAccountStatus?.data || authData?.user?.type === UserType.user) &&
          !authData?.user?.email
        ) {
          return this._router.parseUrl('/login/existing_account');
        } else {
          return true;
        }
      })
    );
  }
}
